function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
var _React_PureComponent;
class StaticText extends (_React_PureComponent = React.PureComponent) {
    render() {
        return /*#__PURE__*/ _jsx("div", {
            id: this.props.id,
            className: classnames('input-container', this.props.className),
            children: /*#__PURE__*/ _jsx("div", {
                className: "form-control form-control--static-text",
                children: this.props.value
            })
        });
    }
}
_define_property(StaticText, "propTypes", {
    // Explicit props
    id: PropTypes.string,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ])
});
export default StaticText;
